import PersonalDeveloperLogo from '../assets/api_pricing/pricing1.svg';
import PersonalStarterLogo from '../assets/api_pricing/pricing2.svg';
import StarterPlusLogo from '../assets/api_pricing/pricing7.svg';
import ScaleUpLogo from '../assets/api_pricing/pricing4.svg';
import PremiumScaleUpLogo from '../assets/api_pricing/pricing5.svg';
import EnterpriseLogo from '../assets/api_pricing/pricing6.svg';
import PersonalStarterPlusLogo from '../assets/api_pricing/pricing8.svg';
import StarterLogo from '../assets/api_pricing/pricing9.svg';

const PricingCard1 = {
  planType: 'noncommercial',
  logo: PersonalDeveloperLogo,
  header: {
    title: 'PERSONAL / DEVELOPER',
    priceMonthly: '',
    priceAnnually: '',
    free: true,
    comingSoon: true,
    contactUs: false,
    contactUsForPrice: false,
  },
  content: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Non-commercial use',
          withQuestionMark: true,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'Any news feed must link to <i>cityfalcon.ai</i> and display "Powered by CityFALCON"',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '10 requests per hour',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 10 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Search by ticker, topics, securities across all asset classes',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Filter by language, relevance, time period, and source',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search content up to a month old',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with a 3-hour delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Basic email support (replies within 96 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  contentMobile: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Non-commercial use',
          withQuestionMark: true,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'Any news feed must link to <i>cityfalcon.ai</i> and display "Powered by CityFALCON"',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '10 requests per hour',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 10 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Search by ticker, topics, securities across all asset classes',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Filter by language, relevance, time period, and source',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search content up to a month old',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with a 3-hour delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Basic email support (replies within 96 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  tableContentMobile: [
    {
      id: 0,
      title: 'Use',
      bodyContent: {
        text: 'Non-Commercial Use',
        withQuestionMark: true,
      },
    },
    {
      id: 1,
      title: 'Whitelabelled',
      bodyContent: {
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 5,
      title: 'Limits',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 6,
      title: 'Maximum API Calls',
      bodyContent: {
        text: '10/hour',
      },
    },
    {
      id: 8,
      title: 'Delay in news',
      bodyContent: {
        text: '3 hours',
      },
    },
    {
      id: 9,
      title: 'Topics per call',
      bodyContent: {
        text: '10',
      },
    },
    {
      id: 10,
      title: 'Stories per Response',
      bodyContent: {
        text: '100',
      },
    },
    {
      id: 11,
      title: 'Search & Access',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 12,
      title: 'Banlists for Sources and Articles',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 13,
      title: 'Search Parameters',
      bodyContent: {
        text: 'Tickers, Topics',
        className: 'question__help--tooltip',
      },
    },
    {
      id: 14,
      title: 'Max Search Period',
      bodyContent: {
        text: '1 month',
      },
    },
    {
      id: 15,
      title: 'Content Filters',
      bodyContent: {
        text: 'Language, Relevance, Source, Time Period',
      },
    },
    {
      id: 16,
      title: 'Full text search',
      bodyContent: {
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 17,
      title: 'Analytics',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 18,
      title: 'CityFALCON Score',
      textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
      bodyContent: {
        text: 'Available in Higher Plans',
        className: 'link',
      },
    },
    {
      id: 19,
      title: 'NLU tags',
      textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006383357',
      bodyContent: {
        rowSpan: 6,
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 20,
      title: 'Entity Sentiment',
      textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
    },
    {
      id: 21,
      title: 'Sentiment per Story',
      textQuestionMark: 'Indicates how positive or negative a story is overall.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
    },
    {
      id: 22,
      title: 'Key Headlines',
      textQuestionMark: 'A machine-learning-driven set of key headlines for relevant content.',
    },
    {
      id: 23,
      title: 'Analyst ratings',
      textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',

    },
    {
      id: 24,
      title: 'Fundamental metrics ',
      textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
    },
    {
      id: 25,
      title: 'Further Content',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 27,
      title: 'Trending Topics',
      textQuestionMark: 'Topics that are experiencing an unusually high level of activity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
      bodyContent: {
        rowSpan: 2,
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 28,
      title: 'Non-public and Paywalled Content',
    },
    {
      id: 29,
      title: 'Group or Hide Similar Stories',
      textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
      bodyContent: {
        text: 'Available in Higher Plans',
        className: 'link',
      },
    },
    {
      id: 30,
      title: 'Corporate ESG reports',
      textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
      bodyContent: {
        rowSpan: 8,
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 31,
      title: 'Investor relations documents',
      textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
    },
    {
      id: 32,
      title: 'Reddit Content',
    },
    {
      id: 33,
      title: 'Institutional Transactions',
      textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
    },
    {
      id: 34,
      title: 'Private Company Insights',
      textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
    },
    {
      id: 35,
      title: 'Translation',
    },
    {
      id: 36,
      title: 'Regulatory  Filings',
    },
    {
      id: 37,
      title: 'Insider Transactions',
      textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
      linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
    },
    {
      id: 38,
      title: 'Support',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 39,
      title: 'Support',
      bodyContent: {
        text: 'Email',
      },
    },
    {
      id: 40,
      title: 'Response Time (hours)',
      className: 'center',
      bodyContent: {
        text: '96',
      },
    },
  ],
};

const PricingCard2 = {
  planType: 'noncommercial',
  logo: PersonalStarterLogo,
  header: {
    title: 'PERSONAL STARTER',
    priceMonthly: '50',
    priceAnnually: '480',
    free: false,
    comingSoon: false,
    contactUs: true,
    contactUsForPrice: false,
    isQuarterly: false,
  },
  content: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Non-commercial use',
          withQuestionMark: true,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'Any news feed must link to <i>cityfalcon.ai</i> and display "Powered by CityFALCON"',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '10K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 50 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'p',
          text: '<i>All features in <b>Personal / Developer</b> plan plus:</i>',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email Support (replies within 72 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          comingSoon: false,
        },
      ],
    },
  ],
  contentMobile: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Non-commercial use',
          withQuestionMark: true,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'Any news feed must link to <i>cityfalcon.ai</i> and display "Powered by CityFALCON"',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '10K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 50 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Search by tickers, topics, sectors, locations',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Filter by language, relevance, time period, and source',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search content up to a month old',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email Support (replies within 72 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          comingSoon: false,
        },
      ],
    },
  ],
  tableContentMobile: [
    {
      id: 0,
      title: 'Use',
      bodyContent: {
        text: 'Non-Commercial Use',
        withQuestionMark: true,
      },
    },
    {
      id: 1,
      title: 'Whitelabelled',
      bodyContent: {
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 5,
      title: 'Limits',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 6,
      title: 'Maximum API Calls',
      bodyContent: {
        text: '10,000/month',
      },
    },
    {
      id: 7,
      title: 'Overage Fee per 10k Calls',
      className: 'center',
      bodyContent: {
        text: '$25 US',
      },
    },
    {
      id: 8,
      title: 'Delay in news',
      bodyContent: {
        text: 'No delay',
      },
    },
    {
      id: 9,
      title: 'Topics per call',
      bodyContent: {
        text: '50',
      },
    },
    {
      id: 10,
      title: 'Stories per Response',
      bodyContent: {
        text: '100',
      },
    },
    {
      id: 11,
      title: 'Search & Access',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 12,
      title: 'Banlists for Sources and Articles',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 13,
      title: 'Search Parameters',
      bodyContent: {
        text: 'Tickers, Topics',
        className: 'question__help--tooltip',
      },
    },
    {
      id: 14,
      title: 'Max Search Period',
      bodyContent: {
        text: '1 month',
      },
    },
    {
      id: 15,
      title: 'Content Filters',
      bodyContent: {
        text: 'Language, Relevance, Source, Time Period',
      },
    },
    {
      id: 16,
      title: 'Full text search',
      bodyContent: {
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 17,
      title: 'Analytics',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 18,
      title: 'CityFALCON Score',
      textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 19,
      title: 'NLU tags',
      textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007925074-CityFALCON-Score',
      bodyContent: {
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
        rowSpan: 6,
      },
    },
    {
      id: 20,
      title: 'Entity Sentiment',
      textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
    },
    {
      id: 21,
      title: 'Sentiment per Story',
      textQuestionMark: 'Indicates how positive or negative a story is overall.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
    },
    {
      id: 22,
      title: 'Key Headlines',
    },
    {
      id: 23,
      title: 'Analyst ratings',
      textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',

    },
    {
      id: 24,
      title: 'Fundamental metrics ',
      textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
    },
    {
      id: 25,
      title: 'Further Content',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 27,
      title: 'Trending Topics',
      textQuestionMark: 'Topics that are experiencing an unusually high level of activity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
      bodyContent: {
        rowSpan: 2,
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 28,
      title: 'Non-public and Paywalled Content',
    },
    {
      id: 29,
      title: 'Group or Hide Similar Stories',
      textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
      bodyContent: {
        text: 'Available in Higher Plans',
        className: 'link',
      },
    },
    {
      id: 30,
      title: 'Corporate ESG reports',
      textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
      bodyContent: {
        rowSpan: 8,
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 31,
      title: 'Investor relations documents',
      textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
    },
    {
      id: 32,
      title: 'Reddit Content',
    },
    {
      id: 33,
      title: 'Institutional Transactions',
      textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
    },
    {
      id: 34,
      title: 'Private Company Insights',
      textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
    },
    {
      id: 35,
      title: 'Translation',
    },
    {
      id: 36,
      title: 'Regulatory  Filings',
    },
    {
      id: 37,
      title: 'Insider Transactions',
      textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
      linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
    },
    {
      id: 38,
      title: 'Support',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 39,
      title: 'Support',
      bodyContent: {
        text: 'Email',
      },
    },
    {
      id: 40,
      title: 'Response Time (hours)',
      bodyContent: {
        text: '48',
      },
    },
  ],
};

const PricingCard3 = {
  planType: 'noncommercial',
  logo: PersonalStarterPlusLogo,
  header: {
    title: 'PERSONAL STARTER PLUS',
    priceMonthly: '100',
    priceAnnually: '960',
    free: false,
    comingSoon: false,
    contactUs: true,
    contactUsForPrice: false,
    isQuarterly: true,
  },
  content: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Non-commercial use',
          withQuestionMark: true,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'Any news feed must link to <i>cityfalcon.ai</i> and display "Powered by CityFALCON"',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '25K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 50 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'p',
          text: '<i>All features in <b>Personal / Developer</b> plan plus:</i>',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email Support (replies within 72 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search by tickers, sectors, locations, asset classes',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Grouping of similar stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          comingSoon: false,
        },
      ],
    },
  ],
  contentMobile: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Non-commercial use',
          withQuestionMark: true,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'Any news feed must link to <i>cityfalcon.ai</i> and display "Powered by CityFALCON"',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '25K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 50 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Search by tickers, topics, sectors, locations',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Filter by language, relevance, time period, and source',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search content up to a month old',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email Support (replies within 72 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search by tickers, sectors, locations, asset classes',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Grouping of similar stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          comingSoon: false,
        },
      ],
    },
  ],
  tableContentMobile: [
    {
      id: 0,
      title: 'Use',
      bodyContent: {
        text: 'Non-Commercial Use',
        withQuestionMark: true,
      },
    },
    {
      id: 1,
      title: 'Whitelabelled',
      bodyContent: {
        text: 'Available in Commercial Plans',
        link: '/products/api/financial-news/pricing-api/commercial',
        className: 'link',
      },
    },
    {
      id: 5,
      title: 'Limits',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 6,
      title: 'Maximum API Calls',
      bodyContent: {
        text: '25,000/month',
      },
    },
    {
      id: 8,
      title: 'Delay in news',
      bodyContent: {
        text: 'No delay',
      },
    },
    {
      id: 9,
      title: 'Topics per call',
      bodyContent: {
        text: '50',
      },
    },
    {
      id: 10,
      title: 'Stories per Response',
      bodyContent: {
        text: '100',
      },
    },
    {
      id: 11,
      title: 'Search & Access',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 12,
      title: 'Banlists for Sources and Articles',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 13,
      title: 'Search Parameters',
      bodyContent: {
        text: 'Tickers, Topics, Sectors, Locations, Asset Classes',
      },
    },
    {
      id: 14,
      title: 'Max Search Period',
      bodyContent: {
        text: '1 month',
      },
    },
    {
      id: 15,
      title: 'Content Filters',
      bodyContent: {
        text: 'Language, Relevance, Source, Time Period',
      },
    },
    {
      id: 16,
      title: 'Full text search',
      bodyContent: {
        text: 'Available in Commercial Plans',
        link: '/products/api/financial-news/pricing-api/commercial',
        className: 'link',
      },
    },
    {
      id: 17,
      title: 'Analytics',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 18,
      title: 'CityFALCON Score',
      textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 19,
      title: 'NLU tags',
      textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006383357',
      bodyContent: {
        rowSpan: 6,
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 20,
      title: 'Entity Sentiment',
      textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
    },
    {
      id: 21,
      title: 'Sentiment per Story',
      textQuestionMark: 'Indicates how positive or negative a story is overall.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
    },
    {
      id: 22,
      title: 'Key Headlines',
    },
    {
      id: 23,
      title: 'Analyst ratings',
      textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',

    },
    {
      id: 24,
      title: 'Fundamental metrics ',
      textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
    },
    {
      id: 25,
      title: 'Further Content',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 27,
      title: 'Trending Topics',
      textQuestionMark: 'Topics that are experiencing an unusually high level of activity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
      bodyContent: {
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
        rowSpan: 2,
      },
    },
    {
      id: 28,
      title: 'Non-public and Paywalled Content',
    },
    {
      id: 29,
      title: 'Group or Hide Similar Stories',
      textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 30,
      title: 'Corporate ESG reports',
      textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
      bodyContent: {
        rowSpan: 8,
        text: 'Available in Commercial Plans',
        className: 'link',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
    {
      id: 31,
      title: 'Investor relations documents',
      textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
    },
    {
      id: 32,
      title: 'Reddit Content',
    },
    {
      id: 33,
      title: 'Institutional Transactions',
      textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
    },
    {
      id: 34,
      title: 'Private Company Insights',
      textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
    },
    {
      id: 35,
      title: 'Translation',
    },
    {
      id: 36,
      title: 'Regulatory  Filings',
    },
    {
      id: 37,
      title: 'Insider Transactions',
      textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
      linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
    },
    {
      id: 38,
      title: 'Support',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 39,
      title: 'Support',
      bodyContent: {
        text: 'Email',
      },
    },
    {
      id: 40,
      title: 'Response Time (hours)',
      className: 'center',
      bodyContent: {
        text: '48',
      },
    },
  ],
};

const PricingCard4 = {
  planType: 'commercial',
  logo: StarterLogo,
  header: {
    title: 'Business Starter',
    priceMonthly: '300',
    priceAnnually: '2880',
    free: false,
    comingSoon: false,
    contactUs: true,
    contactUsForPrice: false,
    isQuarterly: true,
  },
  content: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses with less than $300k in funding and less than $200k in annual revenue',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'Any news feed must link to <i>cityfalcon.ai</i> and display "Powered by CityFALCON"',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '25K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 50 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'p',
          text: '<i>All features in <b>Personal / Developer</b> plan plus:</i>',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email Support (replies within 48 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search by tickers, topics, securities only',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  contentMobile: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses with less than $300k in funding and less than $200k in annual revenue',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'Any news feed must link to <i>cityfalcon.ai</i> and display "Powered by CityFALCON"',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '25K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 50 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Search by tickers, topics, sectors, locations',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Filter by language, relevance, time period, and source',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search content up to a month old',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email Support (replies within 48 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search by tickers, topics, securities only',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          comingSoon: false,
        },
      ],
    },
  ],
  tableContentMobile: [
    {
      id: 0,
      title: 'Use',
      bodyContent: {
        text: 'Commercial Use',
        withQuestionMark: true,
      },
    },
    {
      id: 1,
      title: 'Whitelabelled',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 2,
      title: 'Enterprise Eligibility',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 3,
      title: 'Maximum Revenue',
      bodyContent: {
        text: '$200k',
      },
    },
    {
      id: 4,
      title: 'Maximum Funding',
      bodyContent: {
        text: '$300k',
      },
    },
    {
      id: 5,
      title: 'Limits',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 6,
      title: 'Maximum API Calls',
      bodyContent: {
        text: '25,000/month',
      },
    },
    {
      id: 8,
      title: 'Delay in news',
      bodyContent: {
        text: 'No delay',
      },
    },
    {
      id: 9,
      title: 'Topics per call',
      bodyContent: {
        text: '50',
      },
    },
    {
      id: 10,
      title: 'Stories per Response',
      bodyContent: {
        text: '50',
      },
    },
    {
      id: 11,
      title: 'Search & Access',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 12,
      title: 'Banlists for Sources and Articles',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 13,
      title: 'Search Parameters',
      bodyContent: {
        text: 'Tickers, Topics',
        className: 'question__help--tooltip',
      },
    },
    {
      id: 14,
      title: 'Max Search Period',
      bodyContent: {
        text: '1 month',
      },
    },
    {
      id: 15,
      title: 'Content Filters',
      bodyContent: {
        text: 'Language, Relevance, Source, Time Period',
      },
    },
    {
      id: 16,
      title: 'Full text search',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 17,
      title: 'Analytics',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 18,
      title: 'CityFALCON Score',
      textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 19,
      title: 'NLU tags',
      textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007925074-CityFALCON-Score',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 20,
      title: 'Entity Sentiment',
      textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 21,
      title: 'Sentiment per Story',
      textQuestionMark: 'Indicates how positive or negative a story is overall.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 22,
      title: 'Key Headlines',
      bodyContent: {
        text: 'No',
      },
      textQuestionMark: 'A machine-learning-driven set of key headlines for relevant content.',
    },
    {
      id: 23,
      title: 'Analyst ratings',
      textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 24,
      title: 'Fundamental metrics ',
      textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 25,
      title: 'Further Content',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 27,
      title: 'Trending Topics',
      textQuestionMark: 'Topics that are experiencing an unusually high level of activity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 28,
      title: 'Non-public and Paywalled Content',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 29,
      title: 'Group or Hide Similar Stories',
      textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 30,
      title: 'Corporate ESG reports',
      textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 31,
      title: 'Investor relations documents',
      textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 32,
      title: 'Reddit Content',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 33,
      title: 'Institutional Transactions',
      textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 34,
      title: 'Private Company Insights',
      textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 35,
      title: 'Translation',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 36,
      title: 'Regulatory  Filings',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 37,
      title: 'Insider Transactions',
      textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
      linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 38,
      title: 'Support',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 39,
      title: 'Support',
      bodyContent: {
        text: 'Email',
      },
    },
    {
      id: 40,
      title: 'Response Time (hours)',
      className: 'center',
      bodyContent: {
        text: '96',
      },
    },
  ],
};

const PricingCard5 = {
  planType: 'commercial',
  logo: StarterPlusLogo,
  header: {
    title: 'Starter Plus',
    priceMonthly: '650',
    priceAnnually: '6240',
    free: false,
    comingSoon: false,
    contactUs: true,
    contactUsForPrice: false,
    isQuarterly: true,
  },
  content: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses with less than $300k in funding and less than $200k in annual revenue',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'No attribution required',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '200K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'p',
          text: '<i>All features in <b>Business Starter</b> plan plus:</i>',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email Support (replies within 24 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  contentMobile: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses with less than $300k in funding and less than $200k in annual revenue',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'No attribution required',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '200K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Email Support (replies within 24 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  tableContentMobile: [
    {
      id: 0,
      title: 'Use',
      bodyContent: {
        text: 'Commercial Use',
        withQuestionMark: true,
      },
    },
    {
      id: 1,
      title: 'Whitelabelled',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 2,
      title: 'Enterprise Eligibility',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 3,
      title: 'Maximum Revenue',
      bodyContent: {
        text: '$200k',
      },
    },
    {
      id: 4,
      title: 'Maximum Funding',
      bodyContent: {
        text: '$300k',
      },
    },
    {
      id: 5,
      title: 'Limits',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 6,
      title: 'Maximum API Calls',
      bodyContent: {
        text: '200,000/month',
      },
    },
    {
      id: 8,
      title: 'Delay in news',
      bodyContent: {
        text: 'No delay',
      },
    },
    {
      id: 9,
      title: 'Topics per call',
      bodyContent: {
        text: '100',
      },
    },
    {
      id: 10,
      title: 'Stories per Response',
      bodyContent: {
        text: '100',
      },
    },
    {
      id: 11,
      title: 'Search & Access',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 12,
      title: 'Banlists for Sources and Articles',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 13,
      title: 'Search Parameters',
      bodyContent: {
        text: 'Tickers, Topics',
        className: 'question__help--tooltip',
      },
    },
    {
      id: 14,
      title: 'Max Search Period',
      bodyContent: {
        text: '1 month',
      },
    },
    {
      id: 15,
      title: 'Content Filters',
      bodyContent: {
        text: 'Language, Relevance, Source, Time Period',
      },
    },
    {
      id: 16,
      title: 'Full text search',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 17,
      title: 'Analytics',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 18,
      title: 'CityFALCON Score',
      textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 19,
      title: 'NLU tags',
      textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007925074-CityFALCON-Score',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 20,
      title: 'Entity Sentiment',
      textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 21,
      title: 'Sentiment per Story',
      textQuestionMark: 'Indicates how positive or negative a story is overall.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 22,
      title: 'Key Headlines',
      bodyContent: {
        text: 'No',
      },
      textQuestionMark: 'A machine-learning-driven set of key headlines for relevant content.',
    },
    {
      id: 23,
      title: 'Analyst ratings',
      textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 24,
      title: 'Fundamental metrics ',
      textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 25,
      title: 'Further Content',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 27,
      title: 'Trending Topics',
      textQuestionMark: 'Topics that are experiencing an unusually high level of activity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 28,
      title: 'Non-public and Paywalled Content',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 29,
      title: 'Group or Hide Similar Stories',
      textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 30,
      title: 'Corporate ESG reports',
      textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 31,
      title: 'Investor relations documents',
      textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 32,
      title: 'Reddit Content',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 33,
      title: 'Institutional Transactions',
      textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 34,
      title: 'Private Company Insights',
      textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 35,
      title: 'Translation',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 36,
      title: 'Regulatory  Filings',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 37,
      title: 'Insider Transactions',
      textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
      linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 38,
      title: 'Support',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 39,
      title: 'Support',
      bodyContent: {
        text: 'Email',
      },
    },
    {
      id: 40,
      title: 'Response Time (hours)',
      className: 'center',
      bodyContent: {
        text: '24',
      },
    },
  ],
};

const PricingCard6 = {
  planType: 'commercial',
  logo: ScaleUpLogo,
  header: {
    title: 'Scale Up',
    priceMonthly: '1200',
    priceAnnually: '11520',
    free: false,
    comingSoon: false,
    contactUs: true,
    contactUsForPrice: false,
    isQuarterly: true,
  },
  content: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses with less than $5m in funding and less than $2m in annual revenue',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'No attribution required',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '500K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 200 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'p',
          text: '<i>All features in <b>Starter Plus</b> plan plus:</i>',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Trending topics, securities, and sectors',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email and phone support (replies within 24 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Tags from Natural Language Processing',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  contentMobile: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses with less than $5m in funding and less than $2m in annual revenue',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'No attribution required',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '500K requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 200 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Search by tickers, topics, sectors, locations',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Filter by language, relevance, time period, and source',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search content up to a month old',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Grouping of similar stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Trending topics, securities, and sectors',
          textQuestionMark: 'Named entity recognition extraction and placement in our proprietary taxonomy.',
          linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006383357',
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email and phone support (replies within 24 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Tags from Natural Language Processing',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  tableContentMobile: [
    {
      id: 0,
      title: 'Use',
      bodyContent: {
        text: 'Commercial Use',
        withQuestionMark: true,
      },
    },
    {
      id: 1,
      title: 'Whitelabelled',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 2,
      title: 'Enterprise Eligibility',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 3,
      title: 'Maximum Revenue',
      bodyContent: {
        text: '$2m',
      },
    },
    {
      id: 4,
      title: 'Maximum Funding',
      bodyContent: {
        text: '$5m',
      },
    },
    {
      id: 5,
      title: 'Limits',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 6,
      title: 'Maximum API Calls',
      bodyContent: {
        text: '500,000/month',
      },
    },
    {
      id: 8,
      title: 'Delay in news',
      bodyContent: {
        text: 'No delay',
      },
    },
    {
      id: 9,
      title: 'Topics per call',
      bodyContent: {
        text: '100',
      },
    },
    {
      id: 10,
      title: 'Stories per Response',
      bodyContent: {
        text: '200',
      },
    },
    {
      id: 11,
      title: 'Search & Access',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 12,
      title: 'Banlists for Sources and Articles',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 13,
      title: 'Search Parameters',
      bodyContent: {
        text: 'Tickers, Topics, Sectors, Locations, Asset Classes',
      },
    },
    {
      id: 14,
      title: 'Max Search Period',
      bodyContent: {
        text: '1 month',
      },
    },
    {
      id: 15,
      title: 'Content Filters',
      bodyContent: {
        text: 'Language, Relevance, Source, Time Period',
      },
    },
    {
      id: 16,
      title: 'Full text search',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 17,
      title: 'Analytics',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 18,
      title: 'CityFALCON Score',
      textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 19,
      title: 'NLU tags',
      textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006383357',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 20,
      title: 'Entity Sentiment',
      textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 21,
      title: 'Sentiment per Story',
      textQuestionMark: 'Indicates how positive or negative a story is overall.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 22,
      title: 'Key Headlines',
      bodyContent: {
        text: 'No',
      },
      textQuestionMark: 'A machine-learning-driven set of key headlines for relevant content.',
    },
    {
      id: 23,
      title: 'Analyst ratings',
      textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 24,
      title: 'Fundamental metrics ',
      textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 25,
      title: 'Further Content',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 27,
      title: 'Trending Topics',
      textQuestionMark: 'Topics that are experiencing an unusually high level of activity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 28,
      title: 'Non-public and Paywalled Content',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 29,
      title: 'Group or Hide Similar Stories',
      textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 30,
      title: 'Corporate ESG reports',
      textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 31,
      title: 'Investor relations documents',
      textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 32,
      title: 'Reddit Content',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 33,
      title: 'Institutional Transactions',
      textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 34,
      title: 'Private Company Insights',
      textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 35,
      title: 'Translation',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 36,
      title: 'Regulatory  Filings',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 37,
      title: 'Insider Transactions',
      textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
      linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 38,
      title: 'Support',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 39,
      title: 'Support',
      bodyContent: {
        text: 'Email, Phone',
      },
    },
    {
      id: 40,
      title: 'Response Time (hours)',
      className: 'center',
      bodyContent: {
        text: '16',
      },
    },
  ],
};

const PricingCard7 = {
  planType: 'commercial',
  logo: PremiumScaleUpLogo,
  header: {
    title: 'Premium Scale Up',
    priceMonthly: '4000',
    priceAnnually: '38400',
    free: false,
    comingSoon: false,
    contactUs: true,
    contactUsForPrice: false,
    isQuarterly: true,
    isArchive: true,
  },
  content: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses with less than $5m in funding and less than $2m in annual revenue',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'No attribution required',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '1 million requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 500 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'p',
          text: '<i>All features in <b>Scale Up</b> plan plus:</i>',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Sentiment Scores for Stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Sentiment Analysis of topics, locations, and more',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email and phone support (replies within 12 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search archival content back to 01 Jan 2018',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Full-text search of database for any entity',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Grouping of similar stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Analyst ratings',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Fundamental metrics',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  contentMobile: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses with less than $5m in funding and less than $2m in annual revenue',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'No attribution required',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: '1 million requests per month',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 100 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 500 stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Filter by language, relevance, time period, and source',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search content up to a month old',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Grouping of similar stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Trending topics, securities, and sectors',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Tags from Natural Language Processing',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Sentiment Scores for Stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Sentiment Analysis of topics, locations, and more',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email and phone support (replies within 12 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search archival content back to 01 Jan 2018',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Full-text search of database for any entity',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Grouping of similar stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Analyst ratings',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Fundamental metrics',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  tableContentMobile: [
    {
      id: 0,
      title: 'Use',
      bodyContent: {
        text: 'Commercial Use',
        withQuestionMark: true,
      },
    },
    {
      id: 1,
      title: 'Whitelabelled',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 2,
      title: 'Enterprise Eligibility',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 3,
      title: 'Maximum Revenue',
      bodyContent: {
        text: '$2m',
      },
    },
    {
      id: 4,
      title: 'Maximum Funding',
      bodyContent: {
        text: '$5m',
      },
    },
    {
      id: 5,
      title: 'Limits',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 6,
      title: 'Maximum API Calls',
      bodyContent: {
        text: '1,000,000/month',
      },
    },
    {
      id: 8,
      title: 'Delay in news',
      bodyContent: {
        text: 'No delay',
      },
    },
    {
      id: 9,
      title: 'Topics per call',
      bodyContent: {
        text: '100',
      },
    },
    {
      id: 10,
      title: 'Stories per Response',
      bodyContent: {
        text: '500',
      },
    },
    {
      id: 11,
      title: 'Search & Access',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 12,
      title: 'Banlists for Sources and Articles',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 13,
      title: 'Search Parameters',
      bodyContent: {
        text: 'Tickers, Topics, Sectors, Locations, Asset Classes',
      },
    },
    {
      id: 14,
      title: 'Max Search Period',
      bodyContent: {
        text: 'Full Archive*',
      },
    },
    {
      id: 15,
      title: 'Content Filters',
      bodyContent: {
        text: 'Language, Relevance, Source, Time Period',
      },
    },
    {
      id: 16,
      title: 'Full text search',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 17,
      title: 'Analytics',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 18,
      title: 'CityFALCON Score',
      textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 19,
      title: 'NLU tags',
      textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006383357',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 20,
      title: 'Entity Sentiment',
      textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 21,
      title: 'Sentiment per Story',
      textQuestionMark: 'Indicates how positive or negative a story is overall.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 22,
      title: 'Key Headlines',
      bodyContent: {
        text: 'Yes',
      },
      textQuestionMark: 'A machine-learning-driven set of key headlines for relevant content.',
    },
    {
      id: 23,
      title: 'Analyst ratings',
      textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 24,
      title: 'Fundamental metrics ',
      textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 25,
      title: 'Further Content',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 27,
      title: 'Trending Topics',
      textQuestionMark: 'Topics that are experiencing an unusually high level of activity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 28,
      title: 'Non-public and Paywalled Content',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 29,
      title: 'Group or Hide Similar Stories',
      textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 30,
      title: 'Corporate ESG reports',
      textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 31,
      title: 'Investor relations documents',
      textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 32,
      title: 'Reddit Content',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 33,
      title: 'Institutional Transactions',
      textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 34,
      title: 'Private Company Insights',
      textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 35,
      title: 'Translation',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 36,
      title: 'Regulatory  Filings',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 37,
      title: 'Insider Transactions',
      textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
      linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
      bodyContent: {
        text: 'No',
      },
    },
    {
      id: 38,
      title: 'Support',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 39,
      title: 'Support',
      bodyContent: {
        text: 'Email, Phone',
      },
    },
    {
      id: 40,
      title: 'Response Time (hours)',
      className: 'center',
      bodyContent: {
        text: '8',
      },
    },
  ],
};

const PricingCard8 = {
  planType: 'commercial',
  logo: EnterpriseLogo,
  header: {
    title: 'Enterprise',
    priceMonthly: '',
    priceAnnually: '',
    free: false,
    comingSoon: false,
    contactUs: false,
    contactUsForPrice: true,
    isArchive: true,
  },
  content: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses of any size',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'No attribution required',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: 'Unlimited requests',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'No overages for requests',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 200 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 10K stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'p',
          text: '<i>All features in <b>Premium Scale Up</b> plan plus:</i>',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Premium email and phone support (replies within 12 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Advanced Analytics',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Premium non-public and paywalled content',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Email and phone support (replies within 4 working hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Corporate ESG reports',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Investor relations documents',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Reddit Content',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Institutional Transactions',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Private Company Insights',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Translation',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Regulatory  Filings',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Insider Transactions',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  contentMobile: [
    {
      title: 'Eligibility',
      body: [
        {
          type: 'p',
          text: 'Businesses of any size',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Whitelabelling',
      body: [
        {
          type: 'p',
          text: 'No attribution required',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'API Call Limits',
      body: [
        {
          type: 'i',
          text: 'Unlimited requests',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 200 topics in parameters',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Up to 10K stories per response',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
    {
      title: 'Features',
      body: [
        {
          type: 'i',
          text: 'Filter by language, relevance, time period, and source',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search content up to a month old',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Grouping of similar stories',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Proprietary CityFALCON score',
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Trending topics, securities, and sectors',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Tags from Natural Language Processing',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Sentiment Analysis of topics, locations, and more',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'News articles available with no delay',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Premium email and phone support (replies within 12 hours)',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Search archival content back to 01 Jan 2018',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Advanced Analytics',
          withQuestionMark: false,
          comingSoon: true,
        },
        {
          type: 'i',
          text: 'Premium non-public and paywalled content',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Features section',
          textQuestionMark: 'Summaries condense hundreds of stories into a few bullet points.',
          linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006073397',
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Corporate ESG reports',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Investor relations documents',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Reddit Content',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Institutional Transactions',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Private Company Insights',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Translation',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Regulatory  Filings',
          withQuestionMark: false,
          comingSoon: false,
        },
        {
          type: 'i',
          text: 'Insider Transactions',
          withQuestionMark: false,
          comingSoon: false,
        },
      ],
    },
  ],
  tableContentMobile: [
    {
      id: 0,
      title: 'Use',
      bodyContent: {
        text: 'Commercial Use',
        withQuestionMark: true,
      },
    },
    {
      id: 1,
      title: 'Whitelabelled',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 2,
      title: 'Enterprise Eligibility',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 3,
      title: 'Maximum Revenue',
      bodyContent: {
        text: 'Businesses of any size',
      },
    },
    {
      id: 4,
      title: 'Maximum Funding',
      bodyContent: {
        text: 'Businesses of any size',
      },
    },
    {
      id: 5,
      title: 'Limits',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 6,
      title: 'Maximum API Calls',
      bodyContent: {
        text: 'Unlimited',
      },
    },
    {
      id: 8,
      title: 'Delay in news',
      bodyContent: {
        text: 'No delay',
      },
    },
    {
      id: 9,
      title: 'Topics per call',
      bodyContent: {
        text: '200',
      },
    },
    {
      id: 10,
      title: 'Topics per call',
      bodyContent: {
        text: '10,000',
      },
    },
    {
      id: 11,
      title: 'Search & Access',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 12,
      title: 'Banlists for Sources and Articles',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 13,
      title: 'Search Parameters',
      bodyContent: {
        text: 'Tickers, Topics, Sectors, Locations, Asset Classes',
      },
    },
    {
      id: 14,
      title: 'Max Search Period',
      bodyContent: {
        text: 'Full Archive*',
      },
    },
    {
      id: 15,
      title: 'Content Filters',
      bodyContent: {
        text: 'Language, Relevance, Source, Time Period',
      },
    },
    {
      id: 16,
      title: 'Full text search',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 17,
      title: 'Analytics',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 18,
      title: 'CityFALCON Score',
      textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 19,
      title: 'NLU tags',
      textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006383357',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 20,
      title: 'Entity Sentiment',
      textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 21,
      title: 'Sentiment per Story',
      textQuestionMark: 'Indicates how positive or negative a story is overall.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 22,
      title: 'Key Headlines',
      bodyContent: {
        text: 'Yes',
      },
      textQuestionMark: 'A machine-learning-driven set of key headlines for relevant content.',
    },
    {
      id: 23,
      title: 'Analyst ratings',
      textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 24,
      title: 'Fundamental metrics ',
      textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 25,
      title: 'Further Content',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 27,
      title: 'Trending Topics',
      textQuestionMark: 'Topics that are experiencing an unusually high level of activity.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 28,
      title: 'Non-public and Paywalled Content',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 29,
      title: 'Group or Hide Similar Stories',
      textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
      linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 30,
      title: 'Corporate ESG reports',
      textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
      linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 31,
      title: 'Investor relations documents',
      textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 32,
      title: 'Reddit Content',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 33,
      title: 'Institutional Transactions',
      textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 34,
      title: 'Private Company Insights',
      textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 35,
      title: 'Translation',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 36,
      title: 'Regulatory  Filings',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 37,
      title: 'Insider Transactions',
      textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
      linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
      bodyContent: {
        text: 'Yes',
      },
    },
    {
      id: 38,
      title: 'Support',
      className: 'title',
      bodyContent: {},
    },
    {
      id: 39,
      title: 'Support',
      bodyContent: {
        text: 'Email, Phone',
      },
    },
    {
      id: 40,
      title: 'Response Time (hours)',
      className: 'center',
      bodyContent: {
        text: '4',
      },
    },
  ],
};

export const PricingCards = [
  PricingCard1,
  PricingCard2,
  PricingCard3,
  PricingCard4,
  PricingCard5,
  PricingCard6,
  PricingCard7,
  PricingCard8,
];

export const FAQ = [
  {
    question: 'What’s the delay between publication and availability on the API',
    answer: 'Some publications make their content available instantly while others stipulate we slightly delay content that is published on their website. The delay between publication and appearance on our site can be anywhere from milliseconds to a few minutes depending on the policy of the publication.',
  },
  {
    question: 'May I redistribute the data via API, RSS, XML or similar methods?',
    answer: "No, we generally do not allow redistribution of the content we provide to you.  By default, you are only allowed to show the content on your website or apps to your users or clients.  You can not redistribute via API or similar methods.<br/><br/>Please see our <a href='/eapi_terms'>Terms of Service for the CityFALCON API</a> for more clarity and legal requirements.",
  },
  {
    question: 'Are there call limits? Do you offer a streaming Websockets service?',
    answer: 'There are call limits based on your plan. We have per-hour limits to control usage to a reasonable level to prevent overwhelming our infrastructure, and we have monthly limits by plan level. See our plans for specifics.<br/><br/>We currently do not have any streaming or Websockets services, but we plan to release these features in the future.',
  },
  {
    question: 'Where can I get help with implementation?',
    answer: "We have <a href='https://dev.cityfalcon.com/doc/api/v0.2' target='_blank'>documentation</a> available for developers. If you need further assistance, we may be able to help if you contact us.<br/><br/>You might find some answers in our <a href='https://help.cityfalcon.com/hc/en-us/categories/360001775273-API-and-Historical-Data-Sets'>Knowledge Base</a> as well.",
  },
  {
    question: 'Why can’t I find a particular publication? Can I request one?',
    answer: 'Our sources number over 2000 publications, which we have curated specifically for financial and business content. If you cannot find a publication you want, let us know with a brief explanation. We will review the request, and, if the publication meets our standards for content and credibility, we will add it.<br/><br/>We do appreciate any feedback from users and by telling us about publications, you help us grow our service, too. So don’t hesitate to tell us which publications you want to see included.<br/><br/><span>Note that some publications ask not to be included in our API service, and we respect their wishes.</span>',
  },
  {
    question: 'Which CityFALCON features (CF score, sentiment, etc.)  are available on the API?',
    answer: "The main <code>GET Stories</code> call can take up to 22 parameters, such as language, domain, limit number of results, and minimum CityFALCON score. Which parameters are accessible depends on which subscription plan you choose.<br/><br/>The response is a list of stories, and each story is a dictionary with the Title, Description, associated NLU tags, CityFALCON score, duplicate count, source, author, and language as keys. As other analytics come online, we will extend them to the API. Exactly which keys are returned depends on your subscription as well.<br/><br/>See the <a href='https://dev.cityfalcon.com/doc/api/v0.2' target='_blank'>documentation</a> for more parameters, keys, and details.",
  },
  {
    question: 'Other finance websites have open APIs. Will you have one in the future?',
    answer: 'We intend to release a personal and non-commercial use version of our API for consumers and business in the coming months. You will still need an authentication token, but it is as simple as signing up. The token will be automatically generated for you and you can start right away.',
  },
  {
    question: 'I love your platform, but never coded before. Can you help me build my application?',
    answer: "This depends on multiple factors. We are able to assist with setting up your API access and with some questions. We won’t be able to build the entire application for you, though.</br></br>We are launching a consulting service for enterprises to help them implement projects from start to finish.  <a href='/contact-us'>Reach out to us</a> if you have any interest.",
  },
  {
    question: 'Can I search through historical data?',
    answer: 'Historical data is only available via CSV. Please contact us to request a CSV of the universe and timeframe you need. You can then search through it as you wish.</br></br>This data is not currently available through the API.',
  },
  {
    question: 'What content is available through the API?',
    answer: "Most of the content you would see as a regular user is available via the API. You'll get news stories, CityFALCON analytics, video content, and filings. Of course, some components are only available at the higher API plans.<br/><br/>",
  },
];

export const headerCells = [
  {
    planType: 'commercial',
    plans: [
      {
        id: 'businessStarter',
        value: 'Business Starter',
        logo: StarterLogo,
        plans: [
          {
            id: 0,
            period: 'quarterly',
            priceMonthly: '300',
            isComingSoon: false,
          },
          {
            id: 1,
            period: 'annually',
            priceMonthly: '240',
            isComingSoon: false,
          },
        ],
      },
      {
        id: 'starterPlus',
        value: 'Starter Plus',
        logo: StarterPlusLogo,
        plans: [
          {
            id: 2,
            period: 'quarterly',
            priceMonthly: '650',
            isComingSoon: false,
          },
          {
            id: 3,
            period: 'annually',
            priceMonthly: '520',
            isComingSoon: false,
          },
        ],
      },
      {
        id: 'scaleUp',
        value: 'Scale Up',
        logo: ScaleUpLogo,
        plans: [
          {
            id: 4,
            period: 'quarterly',
            priceMonthly: '1200',
            isComingSoon: false,
          },
          {
            id: 5,
            period: 'annually',
            priceMonthly: '960',
            isComingSoon: false,
          },
        ],
      },
      {
        id: 'premiumScaleUp',
        value: 'Premium Scale Up',
        logo: PremiumScaleUpLogo,
        plans: [
          {
            id: 6,
            period: 'quarterly',
            priceMonthly: '4000',
            isComingSoon: false,
          },
          {
            id: 7,
            period: 'annually',
            priceMonthly: '3200',
            isComingSoon: false,
          },
        ],
      },
      {
        id: 'enterprise',
        value: 'Enterprise',
        logo: EnterpriseLogo,
        plans: [
          {
            id: 8,
            period: 'quarterly',
            price: 'Custom',
            isComingSoon: false,
          },
          {
            id: 9,
            period: 'annually',
            price: 'Custom',
            isComingSoon: false,
          },
        ],
      },
    ],
  },
  {
    planType: 'noncommercial',
    plans: [
      {
        id: 'personal_developer',
        value: 'PERSONAL / DEVELOPER',
        logo: PersonalDeveloperLogo,
        plans: [
          {
            id: 10,
            period: 'semiAnnually',
            price: 'Free',
            isComingSoon: true,
          },
          {
            id: 11,
            period: 'annually',
            price: 'Free',
            isComingSoon: true,
          },
        ],
      },
      {
        id: 'personalStarter',
        value: 'PERSONAL STARTER',
        logo: PersonalStarterLogo,
        plans: [
          {
            id: 10,
            period: 'semiAnnually',
            priceMonthly: '50',
            isComingSoon: false,
          },
          {
            id: 11,
            period: 'annually',
            priceMonthly: '40',
            isComingSoon: false,
          },
        ],
      },
      {
        id: 'personalStarterPlus',
        value: 'PERSONAL STARTER PLUS',
        logo: PersonalStarterPlusLogo,
        plans: [
          {
            id: 12,
            period: 'semiAnnually',
            priceMonthly: '100',
            isComingSoon: false,
          },
          {
            id: 13,
            period: 'annually',
            priceMonthly: '80',
            isComingSoon: false,
          },
        ],
      },
    ],
  },
];

export const tableContent = [
  {
    id: 0,
    title: 'Use',
    commercial: {
      className: 'center__border',
      businessStarter: {
      },
      starterPlus: {
      },
      scaleUp: {
        text: 'Commercial Use',
        withQuestionMark: true,
      },
      premiumScaleUp: {
      },
      enterprise: {
      },
    },
    noncommercial: {
      className: 'center__border',
      personal_developer: {
        text: '',
      },
      personalStarter: {
        text: 'Non-Commercial Use',
        withQuestionMark: true,
      },
      personalStarterPlus: {
        text: '',
      },
    },
  },
  {
    id: 1,
    title: 'Whitelabelled',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'Yes',
      },
      scaleUp: {
        text: 'Yes',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {
      className: 'center__link__border',
      personal_developer: {
      },
      personalStarter: {
        text: 'Available in Commercial Plans',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 2,
    title: 'Enterprise Eligibility',
    className: 'title',
    commercial: {
      className: 'title',
      businessStarter: {
      },
      starterPlus: {
      },
      scaleUp: {
      },
      premiumScaleUp: {
      },
      enterprise: {
      },
    },
  },
  {
    id: 3,
    title: 'Maximum Revenue',
    commercial: {
      businessStarter: {
        text: '$200k',
      },
      starterPlus: {
        text: '$200k',
      },
      scaleUp: {
        text: '$2m',
      },
      premiumScaleUp: {
        text: '$2m',
      },
      enterprise: {
        text: 'Businesses of any size',
      },
    },
  },
  {
    id: 4,
    title: 'Maximum Funding',
    commercial: {
      businessStarter: {
        text: '$300k',
      },
      starterPlus: {
        text: '$300k',
      },
      scaleUp: {
        text: '$5m',
      },
      premiumScaleUp: {
        text: '$5m',
      },
      enterprise: {
        text: 'Businesses of any size',
      },
    },
  },
  {
    id: 5,
    title: 'Limits',
    className: 'title',
    commercial: {
      className: 'title',
      businessStarter: {
      },
      starterPlus: {
      },
      scaleUp: {
      },
      premiumScaleUp: {
      },
      enterprise: {
      },
    },
    noncommercial: {
      className: 'title',
      personal_developer: {
      },
      personalStarter: {
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 6,
    title: 'Maximum API Calls',
    commercial: {
      businessStarter: {
        text: '25,000/month',
      },
      starterPlus: {
        text: '200,000/month',
      },
      scaleUp: {
        text: '500,000/month',
      },
      premiumScaleUp: {
        text: '1,000,000/month',
      },
      enterprise: {
        text: 'Unlimited',
      },
    },
    noncommercial: {
      personal_developer: {
        text: '10/hour',
      },
      personalStarter: {
        text: '10,000/month',
      },
      personalStarterPlus: {
        text: '25,000/month',
      },
    },
  },
  {
    id: 8,
    title: 'Delay in news',
    commercial: {
      className: 'center__border',
      businessStarter: {
      },
      starterPlus: {
      },
      scaleUp: {
        text: 'No delay',
      },
      premiumScaleUp: {
      },
      enterprise: {
      },
    },
    noncommercial: {
      personal_developer: {
        text: '3 hours',
      },
      personalStarter: {
        text: 'No delay',
      },
      personalStarterPlus: {
        text: 'No delay',
      },
    },
  },
  {
    id: 9,
    title: 'Topics per call',
    commercial: {
      businessStarter: {
        text: '50',
      },
      starterPlus: {
        text: '100',
      },
      scaleUp: {
        text: '100',
      },
      premiumScaleUp: {
        text: '100',
      },
      enterprise: {
        text: '200',
      },
    },
    noncommercial: {
      personal_developer: {
        text: '10',
      },
      personalStarter: {
        text: '50',
      },
      personalStarterPlus: {
        text: '50',
      },
    },
  },
  {
    id: 10,
    title: 'Stories per Response',
    commercial: {
      businessStarter: {
        text: '100',
      },
      starterPlus: {
        text: '100',
      },
      scaleUp: {
        text: '200',
      },
      premiumScaleUp: {
        text: '500',
      },
      enterprise: {
        text: '10,000',
      },
    },
    noncommercial: {
      className: 'center__border',
      personal_developer: {
      },
      personalStarter: {
        text: '100',
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 11,
    title: 'Search & Access',
    className: 'title',
    commercial: {
      className: 'title',
      businessStarter: {
      },
      starterPlus: {
      },
      scaleUp: {
      },
      premiumScaleUp: {
      },
      enterprise: {
      },
    },
    noncommercial: {
      className: 'title',
      personal_developer: {
      },
      personalStarter: {
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 12,
    title: 'Banlists for Sources and Articles',
    commercial: {
      businessStarter: {
        text: 'Yes',
      },
      starterPlus: {
        text: 'Yes',
      },
      scaleUp: {
        text: 'Yes',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {
      personal_developer: {
        text: 'Yes',
      },
      personalStarter: {
        text: 'Yes',
      },
      personalStarterPlus: {
        text: 'Yes',
      },
    },
  },
  {
    id: 13,
    title: 'Search Parameters',
    textQuestionMark: 'Excludes aggregated entities, i.e., locations, sectors, and topic classes. Example: retrieve news for individual stocks but not general stock news at this level',
    classname: 'question__help--tooltip',
    commercial: {
      businessStarter: {
        text: 'Tickers, Topics',
        classname: 'question__help--tooltip',
      },
      starterPlus: {
        text: 'Tickers, Topics',
        classname: 'question__help--tooltip',
      },
      scaleUp: {
        text: 'Tickers, Topics, Sectors, Locations, Asset Classes',
      },
      premiumScaleUp: {
        text: 'Tickers, Topics, Sectors, Locations, Asset Classes',
      },
      enterprise: {
        text: 'Tickers, Topics, Sectors, Locations, Asset Classes',
      },
    },
    noncommercial: {
      personal_developer: {
        text: 'Tickers, Topics',
        classname: 'question__help--tooltip',
      },
      personalStarter: {
        text: 'Tickers, Topics',
        classname: 'question__help--tooltip',
      },
      personalStarterPlus: {
        text: 'Tickers, Topics, Sectors, Locations, Asset Classes',
      },
    },
  },
  {
    id: 14,
    title: 'Max Search Period',
    commercial: {
      businessStarter: {
        text: '1 month',
      },
      starterPlus: {
        text: '1 month',
      },
      scaleUp: {
        text: '1 month',
      },
      premiumScaleUp: {
        text: 'Full Archive*',
      },
      enterprise: {
        text: 'Full Archive*',
      },
    },
    noncommercial: {
      className: 'center__border',
      personal_developer: {
      },
      personalStarter: {
        text: '1 month',
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 15,
    title: 'Content Filters',
    commercial: {
      className: 'center__border',
      businessStarter: {
      },
      starterPlus: {
        colSpan: 3,
        text: 'Language, Relevance, Source, Time Period',
      },
      enterprise: {
      },
    },
    noncommercial: {
      className: 'center__border',
      personal_developer: {
        colSpan: 3,
        text: 'Language, Relevance, Source, Time Period',
      },
    },
  },
  {
    id: 16,
    title: 'Full text search',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {
      className: 'center__link__border',
      personal_developer: {
      },
      personalStarter: {
        text: 'Available in Commercial Plans',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 17,
    title: 'Analytics',
    className: 'title',
    commercial: {
      className: 'title',
      businessStarter: {
      },
      starterPlus: {
      },
      scaleUp: {
      },
      premiumScaleUp: {
      },
      enterprise: {
      },
    },
    noncommercial: {
      className: 'title',
      personal_developer: {
      },
      personalStarter: {
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 18,
    title: 'CityFALCON Score',
    textQuestionMark: 'Big Data and AI determine content’s relevance to the user.',
    linkQuestionMark: 'https://www.cityfalcon.ai/features/cf-score',
    commercial: {
      businessStarter: {
        text: 'Yes',
      },
      starterPlus: {
        text: 'Yes',
      },
      scaleUp: {
        text: 'Yes',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {
      personal_developer: {
        text: 'No',
      },
      personalStarter: {
        text: 'Yes',
      },
      personalStarterPlus: {
        text: 'Yes',
      },
    },
  },
  {
    id: 19,
    title: 'NLU tags',
    textQuestionMark: 'Automated extraction and tagging of in-context keywords.',
    linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006383357',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'Yes',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {
      rowSpan: 6,
      className: 'middle__link__border',
      personal_developer: {
        colSpan: 3,
        text: 'Available in Commercial Plans',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
    },
  },
  {
    id: 20,
    title: 'Entity Sentiment',
    textQuestionMark: 'Combines and properly adjusts all associated sentiment scores for the entity.',
    linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360006381518',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 21,
    title: 'Sentiment per Story',
    textQuestionMark: 'Indicates how positive or negative a story is overall.',
    linkQuestionMark: 'https://www.cityfalcon.ai/features/sentiment',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 22,
    title: 'Key Headlines',
    textQuestionMark: 'A machine-learning-driven set of key headlines of relevant content.',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 23,
    title: 'Analyst ratings',
    textQuestionMark: 'Buy, sell, and hold ratings from stock analysts',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 24,
    title: 'Fundamental metrics ',
    textQuestionMark: 'Common financial metrics like market cap and volume through our one-stop API',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 25,
    title: 'Further Content',
    className: 'title',
    commercial: {
      className: 'title',
      businessStarter: {
      },
      starterPlus: {
      },
      scaleUp: {
      },
      premiumScaleUp: {
      },
      enterprise: {
      },
    },
    noncommercial: {
      className: 'title',
      personal_developer: {
      },
      personalStarter: {
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 27,
    title: 'Trending Topics',
    textQuestionMark: 'Topics that are experiencing an unusually high level of  activity.',
    linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007172354',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'Yes',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {
      rowSpan: 2,
      className: 'middle__link__border',
      personal_developer: {
      },
      personalStarter: {
        text: 'Available in Commercial Plans',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 28,
    title: 'Non-public and Paywalled Content',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 29,
    title: 'Group or Hide Similar Stories',
    textQuestionMark: 'AI chooses the most representative story from a group of similar content.',
    linkQuestionMark: 'https://help.cityfalcon.com/hc/en-us/articles/360007780737-Similar-Story-Grouping',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'Yes',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {
      personal_developer: {
        text: 'No',
      },
      personalStarter: {
        text: 'No',
      },
      personalStarterPlus: {
        text: 'Yes',
      },
    },
  },
  {
    id: 30,
    title: 'Corporate ESG reports',
    textQuestionMark: 'News and documents like climate impact summaries, diversity reports, and more.',
    linkQuestionMark: 'https://www.cityfalcon.ai/features/esg',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {
      rowSpan: 8,
      className: 'middle__link__border',
      personal_developer: {
      },
      personalStarter: {
        text: 'Available in Commercial Plans',
        link: '/products/api/financial-news/pricing-api/commercial',
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 31,
    title: 'Investor relations documents',
    textQuestionMark: 'Company presentations, 10-Ks, 10-Qs, and other corporate documents',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 32,
    title: 'Reddit Content',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 33,
    title: 'Institutional Transactions',
    textQuestionMark: 'Fund and other institutional investor positions and reportable portfolio changes',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 34,
    title: 'Private Company Insights',
    textQuestionMark: 'Private company share prices, major investor positions, and more data for non-public companies',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 35,
    title: 'Translation',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 36,
    title: 'Regulatory  Filings',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 37,
    title: 'Insider Transactions',
    textQuestionMark: 'Buys, sells, and option exercises from reporting company insiders.',
    linkQuestionMark: 'http://www.cityfalcon.ai/features/insider-transactions',
    commercial: {
      businessStarter: {
        text: 'No',
      },
      starterPlus: {
        text: 'No',
      },
      scaleUp: {
        text: 'No',
      },
      premiumScaleUp: {
        text: 'No',
      },
      enterprise: {
        text: 'Yes',
      },
    },
    noncommercial: {},
  },
  {
    id: 38,
    title: 'Support',
    className: 'title',
    commercial: {
      className: 'title',
      businessStarter: {
      },
      starterPlus: {
      },
      scaleUp: {
      },
      premiumScaleUp: {
      },
      enterprise: {
      },
    },
    noncommercial: {
      className: 'title',
      personal_developer: {
      },
      personalStarter: {
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 39,
    title: 'Support',
    commercial: {
      businessStarter: {
        text: 'Email',
      },
      starterPlus: {
        text: 'Email',
      },
      scaleUp: {
        text: 'Email, Phone',
      },
      premiumScaleUp: {
        text: 'Email, Phone',
      },
      enterprise: {
        text: 'Email, Phone',
      },
    },
    noncommercial: {
      className: 'center__border',
      personal_developer: {
      },
      personalStarter: {
        text: 'Email',
      },
      personalStarterPlus: {
      },
    },
  },
  {
    id: 40,
    title: 'Response Time (hours)',
    className: 'center',
    commercial: {
      businessStarter: {
        text: '96',
      },
      starterPlus: {
        text: '24',
      },
      scaleUp: {
        text: '16',
      },
      premiumScaleUp: {
        text: '8',
      },
      enterprise: {
        text: '4',
      },
    },
    noncommercial: {
      personal_developer: {
        text: '96',
      },
      personalStarter: {
        text: '48',
      },
      personalStarterPlus: {
        text: '48',
      },
    },
  },
];
